import { API_BASE } from '../config/apiBase';
import { authHeaders, getSessionToken } from './session';

/** Revoke the current session token server-side. Best effort: logout proceeds regardless. */
export async function revokeSession(): Promise<void> {
  if (!getSessionToken()) return;
  try {
    await fetch(`${API_BASE}/api/auth/logout`, { method: 'POST', headers: authHeaders() });
  } catch {
    // offline or server down; the token is dropped locally either way
  }
}
